//local imports
import { IconCard } from 'js/icon-card/iconCard';

// Vendo imports
import React from 'react';
import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';

export class IconsPage extends React.Component {
  filteredPage(url, obj) {
    let symbology = subCategoryStore.getState().symbologyJson;

    if (subCategoryStore.getState().filteredPacks.length > 0) {
      window.location.assign(window.location.pathname + url + '?' + values);
      let obj = {
        text: url + '?' + valuesText,
        link: window.location.pathname + url + '?' + values
      };
      subCategoryActions.appendToBreadCrumbs(obj);
    } else {
      //this.refs.textField.setErrorText("No Icons Found")
    }
  }

  render() {
    let list = subCategoryStore.getState().symbologyJson.packs;
    console.log('ICONS PAGE', list);
    return (
      <div className='card-container'>
        <div className='flex flex-card-container'>
          {list.map(function(item, index) {
            return <IconCard props={{ item: item, index: index }} />;
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/icon-card/iconsPage.js